import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockBagSectionFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const bagBlockConfig = {
  name: 'outer-block-bag',
  component: defineAsyncComponent(() => import('./CmsBagSection.vue')),
  innerComponent: defineAsyncComponent(() => import('./BagBlock.vue')),
  fields: blockBagSectionFields,
} satisfies ModularBlockConfig;
